import { render, staticRenderFns } from "./OrdiniEditComponent.vue?vue&type=template&id=e1ce75fa&scoped=true"
import script from "./OrdiniEditComponent.vue?vue&type=script&lang=js"
export * from "./OrdiniEditComponent.vue?vue&type=script&lang=js"
import style0 from "./OrdiniEditComponent.vue?vue&type=style&index=0&id=e1ce75fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ce75fa",
  null
  
)

export default component.exports